import Vue from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie'
import {Message} from 'view-design'
import $ from 'jquery'
import debounce from 'lodash/debounce'
import MD5 from 'crypto-js/md5'
import pbrTokenManager from '../../apis/manage'

function parseURL (url) {
  var a = document.createElement('a')
  a.href = url
  return {
    source: url,
    protocol: a.protocol.replace(':', ''),
    host: a.hostname,
    port: a.port,
    query: a.search,
    params: (function () {
      var ret = {},
          seg = a.search.replace(/^\?/, '').split('&'),
          len = seg.length, i = 0, s
      for (;i < len; i++) {
        if (!seg[i]) { continue }
        s = seg[i].split('=')
        ret[s[0]] = s[1]
      }
      return ret
    })(),
    file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
    hash: a.hash.replace('#', ''),
    path: a.pathname.replace(/^([^\/])/, '/$1'),
    relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
    segments: a.pathname.replace(/^\//, '').split('/')
  }
}

export const sign = (params = {}, appKey = '', appSecret = '') => {
  const obj = {}
  let str = ''
  for (const k in params) {
    if (['sign', 'appKey'].includes(k) || k instanceof Array || k instanceof Object || params[k] === undefined) {
      continue
    }
    obj[k] = params[k]
  }
  str = encodeURI(`${appKey}${JSON.stringify(obj)}${appSecret}`).toUpperCase()
  str = JSON.stringify(obj)
  console.log('str-------------->', MD5(str))
  return signByStr(str)
}

function signByStr (str) {
  return MD5(str).toString()
}
function sortJson (copy) {
  let obj = Object.assign({}, copy)
  if (typeof copy === 'string' || typeof copy === 'number') {
    return copy
  }
  if (copy instanceof Array) {
    obj = copy
    obj.forEach((co, idx) => {
      obj[idx] = sortJson(co)
    })
    return obj
  }
  var endValue, item, key, keyArray, keyArray2, o, _i, _len
  endValue = {}
  keyArray = []
  keyArray2 = []
  for (key in obj) {
    o = {}
    o[key] = obj[key]
    keyArray.push(key)
  }
  keyArray2 = keyArray.sort()
  for (_i = 0, _len = keyArray2.length; _i < _len; _i++) {
    item = keyArray2[_i]
    if (obj[item] instanceof Array) {
      obj[item].forEach((co, idx) => {
        obj[item][idx] = sortJson(co)
      })
    } else if ((typeof obj[item]) === 'object') {
      if (obj[item] === null) {
        delete obj[item]
        continue
      }
      obj[item] = sortJson(obj[item])
    }
    endValue[item] = obj[item]
  }
  return endValue
};

function commaObjectValue (obj) {
  if (typeof (obj) === 'object') {
    let copyObj = Object.assign({}, obj)
    for (let o in copyObj) {
      if (typeof (copyObj[o]) === 'object') {
        if (copyObj[o] instanceof Array) {
          copyObj[o].forEach((co, idx) => {
            copyObj[o][idx] = commaObjectValue(co)
          })
        } else {
          copyObj[o] = commaObjectValue(copyObj[o])
        }
      } else {
        copyObj[o] = copyObj[o] ? copyObj[o].toString() : ''
      }
    }
    return copyObj
  } else if (typeof (obj) === 'string') {
    return obj
  } else {
    return obj.toString
  }
}

function generateError (content) {
  Message.error({
    background: true,
    content: content,
    duration: 5
  })
}
let showError = debounce(generateError, 1000)
let checkSilkRoadToken = function () {
  return pbrTokenManager.checkSilkRoadToken()
}

let checkToken = debounce(checkSilkRoadToken, 1000)

axios.defaults.withCredentials = true // 允许携带cookie
// axios.defaults.crossDomain=true
const isDev = process.env.NODE_ENV === 'development'
export const baseUrl = isDev ? "/brpa" : window.OauthConfig.brpaUrl;
let cfg = {
  baseURL: baseUrl,
  withCredentials: true,
  timeout: 1000 * 30
}

export const pbrAxios = axios.create(cfg)
pbrAxios.interceptors.request.use(request => {
  // 对接时 取出token
  if (!window.allToken) {
    pbrTokenManager.getSilkRoadToken()
  }

  // let accid = sessionStorage.getItem('accid') ? sessionStorage.getItem('accid') : null
  // if (accid) {
  //   request.headers['accId'] = accid
  // } else {
  //   // delete request.headers.accId
  //   sessionStorage.setItem('accid', '1457541511151689730')
  //   request.headers['accId'] = '1457541511151689730'
  // }


  let timeStamp = (new Date()).getTime()
  if (request.method === 'post') {
    let data = request.data
    let appendParams = {}
    appendParams.from = 'en'
    appendParams.lang = 'en'
    request.data = Object.assign(data, appendParams)
  } else if (request.method === 'get' || request.method === 'delete') {
    let data = request.params
    let appendParams = {}
    appendParams.from = 'en' //request.params.from ? request.params.from : 'en'
    appendParams.lang = 'en'
    request.params = Object.assign({}, request.params, appendParams)
  }
  let requestData = null
  let str = 'TimeStamp' + timeStamp
  let sortResult = ''

  if (request.method === 'post' || request.method === 'put') {
    requestData = Object.assign({}, request.data)
    if (request.data instanceof Array) {
      requestData = request.data
    }
    sortResult = JSON.stringify(sortJson(requestData))
    sortResult = sortResult.replaceAll('\\', '')
  } else if (request.method === 'get' || request.method === 'delete') {
    let myParseUrl = parseURL(request.url)
    requestData = Object.assign({}, myParseUrl.params, request.params)
    sortResult = JSON.stringify(requestData)
  }

  str += sortResult.replaceAll('"', '').replaceAll("\'", '')

  console.log(str)

  let sign = signByStr(str)
  request.headers['timeStamp'] = timeStamp
  request.headers['sign'] = sign

  return request
})
pbrAxios.interceptors.response.use(response => {
  if (response && response.status === 200) {
    if (response.data.code === 200) {
      return response.data
    } else {
      // if (!response.data) {
      //   Message.error({
      //     background: true,
      //     content: response.data.message
      //   })
      // }
      return response.data
    }
  } else {
    // showError('请求失败')
    // Message.error({
    //   background: true,
    //   content: '请求失败'
    // })
  }
}, (error, res) => {
  if (error.response && error.response.status === 401) {
    // Message.error({
    //   background: true,
    //   content: '你暂时无权限预览部分内容'
    // })
    // showError('你暂时无权限预览部分内容')
  } else {
    // Message.error({
    //   background: true,
    //   content: '请求被拒绝' + error
    // })


    // let content = error.response ? ': ' + error.response.status + ' - ' + error.response.data.message : ''
    // showError('请求被拒绝' + content)
  }
})

Vue.prototype.$pbrAxios = pbrAxios
